import { MenuItem, Stack, TextField, Typography } from "@mui/material";
import type { SecureVolumeProduct } from "../../store/types/secureVolume.types";
import { formatProductPeriod } from "./productLabels";

interface SecureVolumeProductSelectProps {
  products: SecureVolumeProduct[];
  value: number | undefined;
  onChange: (productNo: number) => void;
  disabled?: boolean;
  sx?: object;
}

/** Produktval för volymsäkring – visar längd, förvaltningsperiod och målår per produkt */
export const SecureVolumeProductSelect = ({
  products,
  value,
  onChange,
  disabled,
  sx,
}: SecureVolumeProductSelectProps) => (
  <TextField
    select
    size="small"
    label="Produkt"
    value={value ?? ""}
    onChange={(e) => onChange(Number(e.target.value))}
    disabled={disabled || products.length === 0}
    sx={{ minWidth: 320, ...sx }}
    slotProps={{
      select: {
        renderValue: (selected) => {
          const p = products.find((x) => x.productNo === Number(selected));
          return p ? `${p.productName} · handlar för ${p.defaultTargetYear}` : "";
        },
      },
    }}
  >
    {products.map((p) => (
      <MenuItem key={p.productNo} value={p.productNo}>
        <Stack>
          <Typography variant="body2">{p.productName}</Typography>
          <Typography variant="caption" color="text.secondary">
            {formatProductPeriod(p)}
          </Typography>
        </Stack>
      </MenuItem>
    ))}
  </TextField>
);
